module.exports = __webpack_public_path__ + "static/media/default-profile.88017be7.png";